import script from "./TermsServiceContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsServiceContent.vue?vue&type=script&lang=ts&setup=true"

import "./TermsServiceContent.vue?vue&type=style&index=0&id=77e43dec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e43dec"]])

export default __exports__